import React from "react";
import ReceivePayment from "../invoices/ReceivePayment";
import { ROUTE_ADMIN_CUSTOMERS } from "../../app/routes";

const AdminCustomersReceivePayment = ({ match }) => {
  return <ReceivePayment redirectUrl={ROUTE_ADMIN_CUSTOMERS} match={match} />;
};

export default AdminCustomersReceivePayment;
